/* ============================================================
   BLANO — Shopify Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Header Scroll + Transparency ---- */
  const header = document.querySelector('.site-header');
  const body = document.body;
  const isHomepage = body.classList.contains('template-index');

  function updateHeader() {
    if (!header) return;

    const scrolled = window.scrollY > 10;

    if (isHomepage) {
      header.classList.toggle('scrolled', scrolled);
      header.classList.toggle('header-transparent', !scrolled);
      body.classList.toggle('header-scrolled-home', scrolled);
    } else {
      header.classList.add('nav-solid');
      header.classList.remove('header-transparent');
      body.classList.remove('header-scrolled-home');
    }
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  /* ---- Mobile Menu ---- */
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }

  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  }

  /* ---- Search Drawer ---- */
  const searchToggle = document.getElementById('search-toggle');
  const searchClose = document.getElementById('search-close');
  const searchDrawer = document.getElementById('search-drawer');
  const searchInput = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');
  const searchSuggestions = document.getElementById('search-suggestions');
  let searchTimeout;

  function openSearch() {
    if (searchDrawer) searchDrawer.classList.add('open');
    closeMobileMenu();
    setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 300);
  }

  function closeSearch() {
    if (searchDrawer) searchDrawer.classList.remove('open');
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    if (searchSuggestions) searchSuggestions.style.display = '';
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', openSearch);
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const q = this.value.trim();
      clearTimeout(searchTimeout);

      if (q.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        if (searchSuggestions) searchSuggestions.style.display = '';
        return;
      }

      if (searchSuggestions) searchSuggestions.style.display = 'none';
      searchTimeout = setTimeout(() => doSearch(q), 300);
    });
  }

  function doSearch(query) {
    if (!searchResults) return;

    searchResults.innerHTML = '<p class="search-label" style="margin-top:0">Searching...</p>';

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
      .then((response) => response.json())
      .then((data) => {
        const products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) || [];

        if (!products.length) {
          searchResults.innerHTML = `<p style="font-size:14px;color:#717171;padding:1rem 0">No results for "${query}"</p>`;
          return;
        }

        searchResults.innerHTML = `
          <p class="search-label" style="margin-top:0">${products.length} result${products.length !== 1 ? 's' : ''}</p>
          <div class="search-grid">
            ${products.slice(0, 8).map((product) => `
              <a href="${product.url}" class="search-card">
                <div class="search-card-img">
                  <img src="${product.featured_image ? product.featured_image.url + '&width=300' : ''}" alt="${product.title}" loading="lazy">
                </div>
                <p class="search-card-brand">${product.vendor || ''}</p>
                <p class="search-card-name">${product.title}</p>
                <p class="search-card-price">${product.price ? formatMoney(product.price) : 'Price on request'}</p>
              </a>
            `).join('')}
          </div>
        `;
      })
      .catch(() => {
        searchResults.innerHTML = '<p style="font-size:14px;color:#717171;">Search unavailable. Try the search page.</p>';
      });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 0
    }).format(cents / 100);
  }

  /* ---- Accordion ---- */
  document.querySelectorAll('.accordion-trigger').forEach((button) => {
    button.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const content = document.getElementById(this.getAttribute('aria-controls'));

      this.setAttribute('aria-expanded', String(!expanded));

      if (content) {
        content.classList.toggle('open', !expanded);
      }
    });
  });

  /* ---- Footer Accordion (mobile) ---- */
  document.querySelectorAll('.footer-accordion-trigger').forEach((button) => {
    button.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = content && content.classList.contains('open');

      document.querySelectorAll('.footer-accordion-content').forEach((panel) => {
        panel.classList.remove('open');
      });

      if (!isOpen && content) {
        content.classList.add('open');
      }
    });
  });

  /* ---- Product Image Gallery ---- */
  const mainImg = document.getElementById('product-main-img');

  document.querySelectorAll('.product-thumbnail').forEach((thumb) => {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = this.dataset.full || this.src;
      }

      document.querySelectorAll('.product-thumbnail').forEach((item) => {
        item.classList.remove('active');
      });

      this.classList.add('active');
    });
  });

  /* ---- Inquiry Modal ---- */
  const inquiryModal = document.getElementById('inquiry-modal');
  const openInquiryBtns = document.querySelectorAll('[data-open-inquiry]');
  const closeInquiryBtn = document.getElementById('close-inquiry-modal');
  const inquiryForm = document.getElementById('inquiry-form');
  const inquirySuccess = document.getElementById('inquiry-success');
  const inquirySubmitBtn = document.getElementById('inquiry-submit');

  openInquiryBtns.forEach((button) => {
    button.addEventListener('click', () => {
      if (inquiryModal) inquiryModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeInquiry() {
    if (inquiryModal) inquiryModal.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (closeInquiryBtn) {
    closeInquiryBtn.addEventListener('click', closeInquiry);
  }

  if (inquiryModal) {
    inquiryModal.addEventListener('click', function (event) {
      if (event.target === this) {
        closeInquiry();
      }
    });
  }

  if (inquiryForm) {
    inquiryForm.addEventListener('submit', function (event) {
      event.preventDefault();

      if (inquirySubmitBtn) {
        inquirySubmitBtn.disabled = true;
        inquirySubmitBtn.textContent = 'Sending...';
      }

      const data = new FormData(this);
      const bodyData = {
        name: data.get('name'),
        email: data.get('email'),
        phone: data.get('phone'),
        message: data.get('message'),
        product: data.get('product'),
        subject: `Inquiry: ${data.get('product')}`
      };

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'contact',
          utf8: '✓',
          'contact[name]': bodyData.name,
          'contact[email]': bodyData.email,
          'contact[phone]': bodyData.phone || '',
          'contact[body]': `Product: ${bodyData.product}\n\n${bodyData.message}`
        })
      })
        .then(() => {
          if (inquiryForm) inquiryForm.style.display = 'none';
          if (inquirySuccess) inquirySuccess.style.display = 'block';
        })
        .catch(() => {
          if (inquirySubmitBtn) {
            inquirySubmitBtn.disabled = false;
            inquirySubmitBtn.textContent = 'Send Inquiry';
          }
          alert('Something went wrong. Please try again.');
        });
    });
  }

  /* ---- Contact Form ---- */
  const contactForm = document.getElementById('contact-form');
  const contactSuccess = document.getElementById('contact-success');
  const contactSubmitBtn = document.getElementById('contact-submit');

  if (contactForm) {
    contactForm.addEventListener('submit', function (event) {
      event.preventDefault();

      if (contactSubmitBtn) {
        contactSubmitBtn.disabled = true;
        contactSubmitBtn.textContent = 'Sending...';
      }

      const data = new FormData(this);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'contact',
          utf8: '✓',
          'contact[name]': data.get('name'),
          'contact[email]': data.get('email'),
          'contact[body]': `Subject: ${data.get('subject')}\n\n${data.get('message')}`
        })
      })
        .then(() => {
          if (contactForm) contactForm.style.display = 'none';
          if (contactSuccess) contactSuccess.style.display = 'block';
        })
        .catch(() => {
          if (contactSubmitBtn) {
            contactSubmitBtn.disabled = false;
            contactSubmitBtn.textContent = 'Send Message';
          }
        });
    });
  }

  /* ---- Cookie Banner ---- */
  const cookieBanner = document.getElementById('cookie-banner');
  const cookieAccept = document.getElementById('cookie-accept');

  if (cookieBanner && !localStorage.getItem('blano_cookies_accepted')) {
    setTimeout(() => {
      cookieBanner.classList.add('show');
    }, 1500);
  }

  if (cookieAccept) {
    cookieAccept.addEventListener('click', () => {
      localStorage.setItem('blano_cookies_accepted', '1');
      if (cookieBanner) cookieBanner.classList.remove('show');
    });
  }

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.reveal-section, .reveal-item').forEach((element) => {
      observer.observe(element);
    });
  }

  initReveal();

  function applyRevealStagger(scope = document) {
    scope.querySelectorAll('.reveal-item').forEach((element, index) => {
      element.style.transitionDelay = `${(index % 6) * 0.07}s`;
    });
  }

  applyRevealStagger();

  window.BLANO = window.BLANO || {};
  window.BLANO.initReveal = initReveal;
  window.BLANO.applyRevealStagger = applyRevealStagger;

  /* ---- Hero scroll button ---- */
  const heroScrollBtn = document.getElementById('hero-scroll-btn');

  if (heroScrollBtn) {
    heroScrollBtn.addEventListener('click', () => {
      const target = document.getElementById('categories-section');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---- Add to Cart ---- */
  const addToCartBtn = document.getElementById('add-to-cart');

  if (addToCartBtn) {
    const addToCartLabel = addToCartBtn.textContent.trim();
    addToCartBtn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.disabled = true;
      this.textContent = this.dataset.addingLabel || 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then((response) => response.json())
        .then(() => {
          this.textContent = this.dataset.addedLabel || 'Added to Cart';
          setTimeout(() => {
            this.disabled = false;
            this.textContent = addToCartLabel;
          }, 2000);
        })
        .catch(() => {
          this.disabled = false;
          this.textContent = addToCartLabel;
        });
    });
  }

  /* ---- Wishlist / Favorites ---- */
  const WISHLIST_STORAGE_KEY = 'blano_favorites';

  function getWishlist() {
    try {
      const items = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY));
      if (!Array.isArray(items)) return [];
      const ids = new Set();
      return items.filter(item => {
        if (!item || typeof item !== 'object' || !['string','number'].includes(typeof item.id) || !String(item.id).trim() || ids.has(String(item.id))) return false;
        ids.add(String(item.id));
        return true;
      });
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('gml:wishlist-change', { bubbles: true }));
      return true;
    } catch (error) {
      document.dispatchEvent(new CustomEvent('gml:wishlist-error', { bubbles: true }));
      return false;
    }
  }

  let wishlistNoticeTimer;
  function announceWishlist(key) {
    const source = document.querySelector('[data-gml-wishlist-messages]');
    let messages = {};
    try { messages = JSON.parse(source?.textContent || '{}'); } catch (error) { return; }
    if (!messages[key]) return;
    let notice = document.querySelector('[data-gml-wishlist-notice]');
    if (!notice) {
      notice = document.createElement('div');
      notice.dataset.gmlWishlistNotice = '';
      notice.className = 'gml-wishlist-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.append(notice);
    }
    clearTimeout(wishlistNoticeTimer);
    notice.textContent = messages[key];
    notice.hidden = false;
    wishlistNoticeTimer = setTimeout(() => { notice.hidden = true; }, 4500);
  }

  function updateHeaderWishlistBadge() {
    const badge = document.getElementById('header-wishlist-badge');
    if (!badge) return;

    const wishlist = getWishlist();
    badge.classList.toggle('is-visible', wishlist.length > 0);
  }

  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.some((item) => String(item.id) === String(productId));
  }

  function updateWishlistButtonState(button) {
    const productId = button.dataset.productId;
    const active = isInWishlist(productId);

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? (button.dataset.wishlistRemoveLabel || 'Remove from favorites') : (button.dataset.wishlistAddLabel || 'Add to favorites'));
  }

  function toggleWishlist(button) {
    const productId = button.dataset.productId;
    if (!productId) return;

    const wishlist = getWishlist();
    const exists = wishlist.some((item) => String(item.id) === String(productId));

    if (exists) {
      const updated = wishlist.filter((item) => String(item.id) !== String(productId));
      if (!setWishlist(updated)) { announceWishlist('error'); return; }
    } else {
      wishlist.push({
        id: button.dataset.productId,
        handle: button.dataset.productHandle || '',
        url: button.dataset.productUrl || '',
        title: button.dataset.productTitle || '',
        image: button.dataset.productImage || ''
      });
      if (!setWishlist(wishlist)) { announceWishlist('error'); return; }
    }

    announceWishlist(exists ? 'removed' : 'saved');
    updateHeaderWishlistBadge();
    updateWishlistButtonState(button);
  }

  function initWishlistButtons(scope = document) {
    scope.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      updateWishlistButtonState(button);

      if (button.dataset.wishlistBound === 'true') return;
      button.dataset.wishlistBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleWishlist(this);

        if (document.getElementById('wishlist-grid')) {
          renderWishlistPage();
        }
      });
    });
  }

  /* ---- Wishlist Page ---- */
  function renderWishlistPage() {
    const wishlistGrid = document.getElementById('wishlist-grid');
    const wishlistEmpty = document.getElementById('wishlist-empty');
    const wishlistCount = document.getElementById('wishlist-count');

    if (!wishlistGrid) return;

    const wishlist = getWishlist();

    if (wishlistCount) {
      wishlistCount.textContent = `${wishlist.length} ${wishlist.length === 1 ? 'item' : 'items'}`;
    }

    if (!wishlist.length) {
      wishlistGrid.innerHTML = '';
      if (wishlistEmpty) wishlistEmpty.style.display = 'block';
      return;
    }

    if (wishlistEmpty) wishlistEmpty.style.display = 'none';

    wishlistGrid.innerHTML = wishlist.map((item) => `
      <a href="${item.url}" class="wishlist-product-card revealed">
        <div class="wishlist-product-card__media">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          <button
            type="button"
            class="wishlist-btn is-active"
            data-wishlist-toggle
            data-product-id="${item.id}"
            data-product-handle="${item.handle || ''}"
            data-product-url="${item.url || ''}"
            data-product-title="${item.title || ''}"
            data-product-image="${item.image || ''}"
            aria-label="Remove from favorites"
            aria-pressed="true"
          >
            <svg class="wishlist-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 20.364l-7.682-7.682a4.5 4.5 0 116.364-6.364L12 7.636l1.318-1.318a4.5 4.5 0 116.364 6.364L12 20.364z"/>
            </svg>
          </button>
        </div>
        <p class="wishlist-product-card__title">${item.title || ''}</p>
      </a>
    `).join('');

    initWishlistButtons(wishlistGrid);
  }

  function bootWishlistUI() {
    initWishlistButtons();
    renderWishlistPage();
    updateHeaderWishlistBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWishlistUI);
  } else {
    bootWishlistUI();
  }

  const syncWishlistButtons = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateWishlistButtonState);
    updateHeaderWishlistBadge();
  };
  document.addEventListener('gml:wishlist-change', syncWishlistButtons);
  window.addEventListener('storage', event => {
    if (event.key === WISHLIST_STORAGE_KEY || event.key === null) syncWishlistButtons();
  });
  window.BLANO = window.BLANO || {};
  window.BLANO.bootWishlistUI = bootWishlistUI;

  /* ---- Mobile Video Autoplay Reinforcement ---- */
  function forceAutoplayVideos(scope = document) {
    const videos = scope.querySelectorAll('.collection-hero__video');

    videos.forEach((video) => {
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          /*
            Some mobile browsers can still block autoplay in Low Power Mode,
            Data Saver mode, or under specific browser restrictions.
            The next touch/click will retry playback.
          */
        });
      }
    });
  }

  forceAutoplayVideos();

  document.addEventListener('DOMContentLoaded', function () {
    forceAutoplayVideos();
  });

  window.addEventListener('load', function () {
    forceAutoplayVideos();
  });

  document.addEventListener(
    'touchstart',
    function () {
      forceAutoplayVideos();
    },
    { once: true, passive: true }
  );

  document.addEventListener(
    'click',
    function () {
      forceAutoplayVideos();
    },
    { once: true }
  );

  window.BLANO.forceAutoplayVideos = forceAutoplayVideos;
})();

(function () {
  function parseHTML(html) {
    var parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  function refreshCollectionSection(nextUrl, sectionId) {
    var currentSection = document.querySelector('[data-collection-section]');
    if (!currentSection || !sectionId || !nextUrl) return;

    currentSection.classList.add('is-loading');

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var requestUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    fetch(requestUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection filter request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = parseHTML(html);
        var nextSection = doc.querySelector('[data-collection-section]');
        if (!nextSection) throw new Error('Rendered collection section not found');

        currentSection.replaceWith(nextSection);
        window.history.replaceState({}, '', nextUrl);

        if (window.BLANO && typeof window.BLANO.forceAutoplayVideos === 'function') {
          window.BLANO.forceAutoplayVideos(nextSection);
        }

        if (window.BLANO && typeof window.BLANO.bootWishlistUI === 'function') {
          window.BLANO.bootWishlistUI();
        }

        if (window.BLANO && typeof window.BLANO.initReveal === 'function') {
          window.BLANO.initReveal();
        }

        if (window.BLANO && typeof window.BLANO.applyRevealStagger === 'function') {
          window.BLANO.applyRevealStagger(nextSection);
        }

        initCollectionAjaxFilters();
      })
      .catch(function (error) {
        console.error(error);
        window.location.href = nextUrl;
      });
  }

  function bindAjaxLinks(selector) {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;

    var sectionId = section.getAttribute('data-section-id');
    section.querySelectorAll(selector).forEach(function (button) {
      if (button.dataset.ajaxBound === 'true') return;
      button.dataset.ajaxBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        var nextUrl = button.getAttribute('data-filter-url') || button.getAttribute('href');
        refreshCollectionSection(nextUrl, sectionId);
      });
    });
  }

  function initCollectionAjaxFilters() {
    bindAjaxLinks('[data-filter-url]');
    bindAjaxLinks('[data-ajax-pagination]');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAjaxFilters);
  } else {
    initCollectionAjaxFilters();
  }

  window.addEventListener('popstate', function () {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-section-id');
    refreshCollectionSection(window.location.pathname + window.location.search, sectionId);
  });
})();
function positionPricingNotice() {
  document.querySelectorAll('.blano-dealer-note').forEach((notice) => {
    const section = notice.closest('.shopify-section');
    const row = section?.querySelector('.blano-tools-row');

    if (row && notice.parentElement !== row) {
      row.appendChild(notice);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', positionPricingNotice);
} else {
  positionPricingNotice();
}

document.addEventListener('shopify:section:load', positionPricingNotice);